module.exports = __webpack_public_path__ + "static/assets/c4c75827d7f30081f493963fadec60a1.svg";